

// import createBrowserHistory from 'history/createBrowserHistory';

// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
import { createBrowserHistory } from 'history';
export default createBrowserHistory();
// export default process.env.BROWSER && require("history").createBrowserHistory();
